import React, { useState, useEffect } from "react";
import { Container, Row, Col, Button, Breadcrumb, Form } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { Link } from "react-router-dom";
import {
  addDocuments,
  documentCategoryList,
  editDocuments,
  fileUpload,
  updateDocuments,
} from "../../../store/actions";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { useRef } from "react";
import Loading from "../../../Common/extra/loading";
import { MenuItem, Select } from "@material-ui/core";

const AddDocumentIndex = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const compMounted = useRef();
  const [loading, setLoading] = useState(false);
  const userData = useSelector((s) => s?.Documents?.editDocuments?.data);
  const Categories = useSelector((s) => s.DocumentCategories?.categories?.data);
  const id = location.pathname.split("/")[3];
  const [data, setData] = useState({
    userId: "",
    name: "",
    document_categories_id: "",
    status: "1",
  });
  const [errors, setError] = useState({
    name: "",
    disabled: true,
  });

  useEffect(() => {
    dispatch(documentCategoryList());
  }, []);

  useEffect(() => {
    if (compMounted.current) {
      setData((pre) => ({
        ...pre,
        name: userData?.name ? userData?.name : "--",
        document_categories_id: userData?.documentcategories
          ? userData?.documentcategories[0]?.id
          : "",
      }));
    } else {
      compMounted.current = true;
    }
  }, [userData]);
  useEffect(() => {
    if (id) {
      dispatch(editDocuments(id));
    }
    setData((pre) => ({
      ...pre,
      userId: id,
    }));
  }, [id]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    const Error = { ...errors };

    switch (name) {
      case "name":
        Error[name] = "";
        if (value.length < 1) {
          Error[name] = "Required";
          Error["disabled"] = true;
        } else {
          Error["disabled"] = false;

          ("");
        }
        break;

      default:
        break;
    }
    setData((prevState) => ({
      ...prevState,
      [name]: value,
    }));
    setError((pre) => ({ ...pre, ...Error }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    setError((pre) => ({ ...pre, disabled: true }));
    setLoading(true);
    const callBack = (response) => {
      if (response.data) {
        setError((pre) => ({ ...pre, disabled: false }));
        setLoading(false);
        toast.success("Added Successfully");
        setTimeout(() => {
          navigate("/documents");
        }, 500);
      } else {
        setError((pre) => ({ ...pre, disabled: false }));
        setLoading(false);
      }
    };
    if (id) {
      if (data.userId) {
        data.userId = data.userId;
      }
      dispatch(
        updateDocuments(
          {
            ...data,
            document_categories_id: JSON.stringify([
              data.document_categories_id,
            ]),
          },
          callBack
        )
      );
    } else {
      dispatch(
        addDocuments(
          {
            ...data,
            document_categories_id: JSON.stringify([
              data.document_categories_id,
            ]),
          },
          callBack
        )
      );
    }
  };
  return (
    <>
      {loading && <Loading className={"cstmLoader"} />}
      <section className="dashboard profile-main py-2">
        <Container>
          <Row>
            <Col lg="12" className="my-2">
              <div className="top mb-2">
                <Breadcrumb>
                  <Breadcrumb.Item href="/documents">Documents</Breadcrumb.Item>
                  <Breadcrumb.Item active>
                    {id ? "Edit" : "Add"}
                  </Breadcrumb.Item>
                </Breadcrumb>
              </div>
            </Col>
            <Col lg="12" className="my-2">
              <div className="bg-white card-box px-4 py-3 rounded">
                <Form>
                  <Row>
                    <Col lg="6" className="my-2">
                      <label htmlFor="" className="form-label2 m-0">
                        Name
                      </label>
                      <input
                        type="text"
                        name="name"
                        value={data?.name}
                        onChange={handleChange}
                        placeholder=""
                        className="form-control"
                      />
                      <span className="note error_note py-2 m-0 text-danger">
                        {errors.name}
                      </span>
                    </Col>

                    <Col lg="6" className="my-2 doc-select">
                      <label htmlFor="" className="form-label2 m-0">
                        Document Category
                      </label>
                      <Select
                        className="demo-simple-select-label"
                        id="demo-simple-select"
                        name="document_categories_id"
                        value={data.document_categories_id}
                        onChange={handleChange}
                        MenuProps={Categories}
                      >
                        {Categories &&
                          Categories.length > 0 &&
                          Categories.map((item, idx) => {
                            return (
                              <MenuItem key={item.id} value={item.id}>
                                {item.name}
                              </MenuItem>
                            );
                          })}
                      </Select>
                    </Col>

                    <Col lg="12" className="my-2">
                      <div className="pt-4 btn-wrp d-flex algign-items-center">
                        <Button
                          disabled={errors.disabled}
                          onClick={handleSubmit}
                          className="d-flex align-items-center justify-content-center me-2"
                        >
                          Submit
                        </Button>
                        <Link
                          to={`/documents`}
                          className="d-flex btn-2 border align-items-center justify-content-center me-2"
                        >
                          <span className="me-2">
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              width="12"
                              height="9"
                              viewBox="0 0 12 9"
                              fill="none"
                            >
                              <path
                                d="M2.8725 3.75L5.5575 1.0575L4.5 0L0 4.5L4.5 9L5.5575 7.9425L2.8725 5.25H12V3.75H2.8725Z"
                                fill="black"
                              />
                            </svg>
                          </span>
                          Back
                        </Link>
                      </div>
                    </Col>
                  </Row>
                </Form>
              </div>
            </Col>
          </Row>
        </Container>
      </section>
    </>
  );
};
export default AddDocumentIndex;
